import i18next from 'i18next'
import { sacConstants } from '../../constants/sac_constants'
import { sacService } from '../../services/sacService'
import { alertActions } from './alert_actions'

export const sacActions = {
  getAll,
  create,
  remove,
  update,
  getById,
  clearUserData,
}

function getAll() {
  return (dispatch) => {
    dispatch(request())
    sacService.getAll().then(
      (users) => {
        dispatch(success(users))
      },
      (error) => {
        dispatch(failure(error))
      },
    )
  }

  function request() {
    return { type: sacConstants.GET_SAC_USERS_REQUEST }
  }

  function success(users) {
    return { type: sacConstants.GET_SAC_USERS_SUCCESS, users }
  }

  function failure(error) {
    return { type: sacConstants.GET_SAC_USERS_FAILURE, error }
  }
}

function create(user, onSuccess) {
  return (dispatch) => {
    dispatch(request())
    sacService.create(user).then(
      (response) => {
        dispatch(success())
        dispatch(getAll())
        dispatch(
          alertActions.success(
            i18next.t('services.userGenerics.createSuccess'),
          ),
        )
        onSuccess()
      },
      (error) => {
        dispatch(failure(error))
        dispatch(
          alertActions.error(i18next.t('services.userGenerics.createError')),
        )
        dispatch(clearUserData())
      },
    )
  }

  function request() {
    return { type: sacConstants.SAC_CREATE_USER_REQUEST }
  }

  function failure(error) {
    return { type: sacConstants.SAC_CREATE_USER_FAILURE, error }
  }

  function success() {
    return { type: sacConstants.SAC_CREATE_USER_SUCCESS }
  }
}

function remove(id) {
  return (dispatch) => {
    sacService.remove(id).then(
      (_) => {
        dispatch(getAll())
        dispatch(
          alertActions.success(
            i18next.t('services.userGenerics.deleteSuccess'),
          ),
        )
      },
      (error) => {
        dispatch(
          alertActions.error(i18next.t('services.userGenerics.deleteError')),
        )
      },
    )
  }
}

function update(user, onSuccess) {
  const { id } = user
  delete user.id

  return (dispatch) => {
    dispatch(request())
    sacService.update(id, user).then(
      (response) => {
        dispatch(success())
        dispatch(getAll())
        dispatch(
          alertActions.success(
            i18next.t('services.userGenerics.updateSuccess'),
          ),
        )
        onSuccess()
      },
      (error) => {
        dispatch(failure(error))
        dispatch(
          alertActions.error(i18next.t('services.userGenerics.updateError')),
        )
        dispatch(clearUserData())
      },
    )
  }

  function request() {
    return { type: sacConstants.SAC_UPDATE_USER_REQUEST }
  }

  function failure(error) {
    return { type: sacConstants.SAC_UPDATE_USER_FAILURE, error }
  }

  function success() {
    return { type: sacConstants.SAC_UPDATE_USER_SUCCESS }
  }
}

function getById(id) {
  return (dispatch) => {
    dispatch(request())
    sacService.getById(id).then(
      (user) => {
        dispatch(success(user))
      },
      (error) => {
        dispatch(failure(error))
      },
    )
  }

  function request() {
    return { type: sacConstants.GET_SAC_USER_BY_ID_REQUEST }
  }

  function success(user) {
    return { type: sacConstants.GET_SAC_USER_BY_ID_SUCCESS, user }
  }

  function failure(error) {
    return { type: sacConstants.GET_SAC_USERS_FAILURE, error }
  }
}

function clearUserData() {
  return (dispatch) => dispatch({ type: sacConstants.SAC_CLEAR_USER_DATA })
}
